import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {BwTogglerComponent} from "../../components/bw-toggler/bw-toggler.component";

@Component({
  selector: 'app-bw-toggler',
  templateUrl: './bw-toggler.component.html',
  styleUrls: ['./bw-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BwTogglerComponent21 extends BwTogglerComponent{
  public isDayTogglerChecked = false;

  @Input() modeItem;

  ngOnInit() {
    this.provider.bwToggle = this;
    this.provider.selectedModeChanged.subscribe(({name, mode})=>{
      this.isDayTogglerChecked = mode.id == '-1';
      this.cd.detectChanges();
    });
  }

  onDayTogglerChanged(){
    this.isDayTogglerChecked = !this.isDayTogglerChecked;
    this.provider.setCurrentViewModeGrayScale((this.isDayTogglerChecked) ? 0 : 1);
    this.cd.markForCheck();
  }

}
